import React from "React";
import ScrollMenu from "react-horizontal-scrolling-menu";
import techs from "../../data/technologies.json";

const TechnologyItem: React.FC = (props) => {
  const toMenuItems = (list) => {
    let i = 0;
    let nList = [];
    for (let i = 0; i < list.length; i += 2) {
      nList.push(
        <div
          key={"usedto" + i}
          className="grid justify-center  pointer-events-none grid-flow-row px-4 md:px-12 focus:outline-none"
        >
          <div className="pb-5 flex  pointer-events-none flex-col self-center items-center ">
            <img
              src={"../../img/tech/" + list[i].icon}
              className="h-16 w-16 pointer-events-none"
              style={{
                objectFit: "contain",
              }}
            ></img>
            <div className="text-center pt-2">{list[i].name}</div>
          </div>
          {list[i + 1] && (
            <div className="pb-5 flex flex-col self-center items-center ">
              <img
                src={"../../img/tech/" + list[i + 1].icon}
                className="h-16 w-16"
                style={{
                  objectFit: "contain",
                }}
              ></img>
              <div className="text-center pt-2">{list[i + 1].name}</div>
            </div>
          )}
        </div>
      );
    }
    return nList;
  };
  return (
    <ScrollMenu
      data={toMenuItems(techs)}
      itemClass="pointer-events-none"
      itemClassActive=""
      inertiaScrolling={true}
      scrollBy={2}
      transition={1}
      clickWhenDrag={false}
      arrowLeft={<div className="">{"<"}</div>}
      arrowRight={<div className="">{">"}</div>}
      alignCenter={false}
      dragging={true}
      wheel={true}
      scrollToSelected={false}
      hideSingleArrow={true}
      hideArrows={true}
    />
  );
};

export default TechnologyItem;
